
import HeroImage from '@/components/home/hero-image.vue'
import HeroLayer from '@/components/home/hero-layer.vue'
import HeroContent from '@/components/home/hero-content.vue'
export default {
  name: 'Hero',
  components: { HeroContent, HeroLayer, HeroImage }
}
